/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable no-param-reassign */
import React, {
  useState,
  useContext,
  useRef,
} from 'react';
import { useTranslation } from 'react-i18next';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import moment from 'moment-timezone';

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import { formatCurrency } from '../../../service/utils';
import Remove from '../modals/Remove';
import UpdateStatus from '../modals/UpdateStatus';
import EditBill from '../modals/EditBill';
import api from '../../../service/axios/api';
import FlashContext from '../../../components/contexts/FlashContext';
import Boleto from '../modals/Boleto';
import EditPaidBill from '../modals/EditPaidBill';

const useStyles = makeStyles({
  root: { width: '100%' },
  container: { maxHeight: 440 },
  table: { minWidth: 1100 },
});

const StyledTableCell = withStyles(() => ({
  head: { backgroundColor: '#303474', color: 'white' },
  body: { fontSize: 14 },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

// eslint-disable-next-line import/prefer-default-export
export function BillsTableRow({ docs, searchData }) {
  const { t } = useTranslation();
  const { notifyError, notifySuccess } = useContext(FlashContext);
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);

  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);

  const [loadingDelete, setLoadingDelete] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const [openEdit, setOpenEdit] = useState(false);
  const [loadingEdit, setLoadingEdit] = useState(false);
  const [editObs, setEditObs] = useState('');
  const [editAmount, setEditAmount] = useState('');
  const [editDueDate, setEditDueDate] = useState(null);
  const [editCategory, setEditCategory] = useState('');
  const [editPayingMethod, setEditPayingMethod] = useState('');
  const [editStatus, setEditStatus] = useState('');
  const [editType, setEditType] = useState('');
  const [editPredictedValue, setEditPredictedValue] = useState('');
  const [editNfeNumber, setEditNfeNumber] = useState('');
  const [editDateIssue, setEditDateIssue] = useState(null);
  const [editBankId, setEditBankId] = useState(null);
  const [editSupplier, setEditSupplier] = useState(null);
  const [editCenter, setEditCenter] = useState(null);
  const [editRecurrenceType, setEditRecurrenceType] = useState('');
  const [editOriginalRecurrenceType, setEditOriginalRecurrenceType] = useState('');
  const [editInstallmentsCount, setEditInstallmentsCount] = useState('');
  const [editInstallmentNumber, setEditInstallmentNumber] = useState(null);
  const [editInstallmentTotal, setEditInstallmentTotal] = useState(null);
  const [openBoleto, setOpenBoleto] = useState(false);
  const [loadingBoleto, setLoadingBoleto] = useState(false);
  const [openEditPaid, setOpenEditPaid] = useState(false);
  const [loadingEditPaid, setLoadingEditPaid] = useState(false);
  const [editRealizedValue, setEditRealizedValue] = useState('');

  const fileRef = useRef(null);

  const handleMenu = event => {
    if (docs.status !== 'Cancelada') setAnchorEl(event.currentTarget);
  };

  const parseDate = (dateStr) => {
  if (!dateStr) return null;
  const date = new Date(dateStr);
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 12, 0, 0);
};

const handleOpenEditPaid = () => {
  setEditObs(docs.observation || '');
  setEditType(docs.type || '');
  setEditNfeNumber(docs.nfe_number || '');
  setEditDateIssue(docs.date_issue ? parseDate(docs.date_issue) : null);
  setEditBankId(docs.bank_id || null);
  setEditRealizedValue(docs.realized_value ? String(docs.realized_value) : '');
  setAnchorEl(null);
  setOpenEditPaid(true);
};

const handleEditPaid = async () => {
  if (!editType) { notifyError('Informe o tipo'); return; }

   const moneyRegex = /^\d+([.,]\d{1,2})?$/;
  if (!editRealizedValue || !moneyRegex.test(editRealizedValue)) {
    notifyError('Insira um valor pago válido');
    return;
  }

  setLoadingEditPaid(true);
  try {
    const { data } = await api.billsToPay.editBill(docs.id, {
      observation: editObs,
      type: editType,
      nfe_number: editNfeNumber,
      date_issue: editDateIssue,
      bank_id: editBankId,
      realized_value: editRealizedValue,
    });
    notifySuccess(data.message);
    setOpenEditPaid(false);
    searchData()
  } catch (error) {
    if (error.problems?.length > 0) error.problems.forEach(err => notifyError(err.msg));
    else notifyError(error.message);
  } finally {
    setLoadingEditPaid(false);
  }
};


const handleOpenEdit = () => {
  setEditObs(docs.observation || '');
  setEditPredictedValue(docs.predicted_value ? String(docs.predicted_value) : '');
  setEditDueDate(docs.due_date ? parseDate(docs.due_date) : null);
  setEditPayingMethod(docs.paying_method || '');
  setEditStatus(docs.status || '');
  setEditType(docs.type || '');
  setEditNfeNumber(docs.nfe_number || '');
  setEditDateIssue(docs.date_issue ? parseDate(docs.date_issue) : null);
  setEditBankId(docs.bank_id || null);
  setEditSupplier(docs.supplier_id || null);
  setEditCategory(docs.category_id || null );
  setEditCenter(docs.cost_center_id || null);
  setEditRecurrenceType(docs.recurrence_type || '');
  setEditOriginalRecurrenceType(docs.recurrence_type || '');
  setEditInstallmentsCount('');
  setEditInstallmentNumber(docs.installment_number || null);
  setEditInstallmentTotal(docs.installment_total || null);
  setAnchorEl(null);
  setOpenEdit(true);
};

const handleSaveBoleto = async ({ barcode, file }) => {
  setLoadingBoleto(true);
  try {
    if (barcode.trim()) {
      const { data } = await api.billsToPay.updateBarCode(docs.id, barcode );
      notifySuccess(data.message);
    }
 
    if (file) {
      const formData = new FormData();
      formData.append('doc', file);
      const { data } = await api.billsToPay.sendBoleto(docs.id, formData);
      notifySuccess(data.message);
    }
    setOpenBoleto(false);
    searchData();
  } catch (error) {
    if (error.problems?.length > 0) error.problems.forEach(err => notifyError(err.msg));
    else notifyError(error.message);
  } finally {
    setLoadingBoleto(false);
  }
};

  const handleEdit = async () => {
  const moneyRegex = /^\d+([.,]\d{1,2})?$/;
  if (!editPredictedValue || !moneyRegex.test(editPredictedValue)) {
    notifyError('Insira um valor previsto válido');
    return;
  }

  if (!editCategory) { notifyError('Informe uma categoria'); return; }
  if (!editPayingMethod?.trim()) { notifyError('Informe um método de pagamento'); return; }
  if (!editType) { notifyError('Informe o tipo'); return; }

   const recorrenciaMudou =
    editInstallmentTotal > 1 && editRecurrenceType !== editOriginalRecurrenceType;

  if (recorrenciaMudou) {
    const qtd = Number(editInstallmentsCount);
    if (!editInstallmentsCount || Number.isNaN(qtd) || qtd < 2 || qtd > 360) {
      notifyError('Informe o novo número de repetições (entre 2 e 360)');
      return;
    }
  }

  setLoadingEdit(true);
  try {
    const { data } = await api.billsToPay.editBill(docs.id, {
      supplier_id: editSupplier,
      cost_center_id: editCenter,
      observation: editObs,
      predicted_value: editPredictedValue,
      due_date: editDueDate,
      category_id: editCategory,
      paying_method: editPayingMethod,
      status: 'Pendente',
      type: editType,
      nfe_number: editNfeNumber,
      date_issue: editDateIssue,
      bank_id: editBankId,
      recurrence_type: editRecurrenceType || undefined,
    });
    notifySuccess(data.message);
    setOpenEdit(false);
    searchData();
  } catch (error) {
    if (error.problems?.length > 0) error.problems.forEach(err => notifyError(err.msg));
    else notifyError(error.message);
  } finally {
    setLoadingEdit(false);
  }
};

  const handleDelete = async () => {
    setLoadingDelete(true);
    try {
      const { data } = await api.billsToPay.updateStatus(docs.id, {
        status : 'Cancelada'
      });
      notifySuccess(data.message);
      setOpenDelete(false);
      searchData();
    } catch (error) {
      if (error.problems && error.problems.length > 0) {
        error.problems.forEach(err => notifyError(err.msg));
      } else {
        notifyError(error.message);
      }
    } finally {
      setLoadingDelete(false);
      setAnchorEl(null);
    }
  };

  const handleUpdate = async ({ realizedValue, dateIssue, bankId, dueDate }) => {
  setLoadingUpdate(true);
  try {
    const { data } = await api.billsToPay.updateStatus(docs.id, {
      realized_value: realizedValue,
      status: 'Pago',
      date_issue: parseDate(dateIssue) || dateIssue,
      bank_id: bankId,
      due_date: parseDate(dueDate) || dueDate,
    });
    notifySuccess(data.message);
    setOpenUpdate(false);
    searchData();
  } catch (error) {
    if (error.problems?.length > 0) error.problems.forEach(err => notifyError(err.msg));
    else notifyError(error.message);
  } finally {
    setLoadingUpdate(false);
    setAnchorEl(null);
  }
};

  const handleOpenInput = () => {
    setAnchorEl(null);
    fileRef.current.click();
  };

  const handleSendProof = async event => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('doc', file);

    try {
      const { data } = await api.billsToPay.sendProof(docs.id, formData);
      notifySuccess(data.message);
      searchData();
    } catch (error) {
      if (error.problems && error.problems.length > 0) {
        error.problems.forEach(err => notifyError(err.msg));
      } else {
        notifyError(error.message);
      }
    } finally {
      event.target.value = null;
      setAnchorEl(null);
    }
  };

  return (
    <>
      <StyledTableRow key={docs.id}>
        <StyledTableCell>{docs.supplier_name || '-'}</StyledTableCell>
        <StyledTableCell>{docs.cost_center_name || '-'}</StyledTableCell>
        <StyledTableCell>{docs.category_name || '-'}</StyledTableCell>
        <StyledTableCell>
          {docs.due_date && moment(docs.due_date).format('DD/MM/YYYY')}
        </StyledTableCell>
        <StyledTableCell>{docs.paying_method || '-'}</StyledTableCell>
        <StyledTableCell>{docs.status || '-'}</StyledTableCell>
        <StyledTableCell>{docs.observation || '-'}</StyledTableCell>
        <StyledTableCell>{docs.type || '-'}</StyledTableCell>
        <StyledTableCell>{formatCurrency(docs.predicted_value || 0)}</StyledTableCell>
        <StyledTableCell>{formatCurrency(docs.realized_value || 0)}</StyledTableCell>
        <StyledTableCell>{docs.nfe_number || '-'}</StyledTableCell>
        <StyledTableCell>
          {docs.date_issue && moment(docs.date_issue).format('DD/MM/YYYY')}
        </StyledTableCell>
        <StyledTableCell>{docs.bank_name || '-'}</StyledTableCell>
        <StyledTableCell
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          {docs.created_at && moment(docs.created_at).format('DD/MM/YYYY')}
          {docs.status !== 'Cancelada' && (
            <MoreVertIcon
              onClick={e => handleMenu(e)}
              fontSize="small"
              style={{ cursor: 'pointer' }}
            />
          )}
        </StyledTableCell>
      </StyledTableRow>

      <Menu
        id="menu-appbar"
        style={{ borderRadius: '25px' }}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {docs.status === 'Pendente' && (
          <>
            <MenuItem onClick={() => { setOpenUpdate(true); setAnchorEl(null); }}>
              Efetuar Pagamento
            </MenuItem>
            <MenuItem onClick={handleOpenEdit}>
              Editar
            </MenuItem>
            <MenuItem onClick={() => { setAnchorEl(null); setOpenBoleto(true); }}> {/* novo */}
              Boleto
            </MenuItem>
             <MenuItem onClick={() => { setAnchorEl(null); setOpenDelete(true); }}>
              Cancelar
           </MenuItem>
          </>
        )}
        {/* Mudar para pago ao depender do enum de bills_to_pay */}
        {docs.status === 'Pago' && (
          <>
            <MenuItem onClick={handleOpenEditPaid}>
              Editar
            </MenuItem>
            {docs.proof ? (
              <MenuItem onClick={() => window.open(docs.proof, '_blank')}>
                {t('billsToPay.table.menu.getProof')}
              </MenuItem>
            ) : (
              <MenuItem onClick={handleOpenInput}>
                {t('billsToPay.table.menu.sendProof')}
              </MenuItem>
            )}
          </>
        )}
      </Menu>

      <Remove
        openDelete={openDelete}
        setOpenDelete={setOpenDelete}
        loadingDelete={loadingDelete}
        handleDelete={handleDelete}
      />
      <UpdateStatus
        openUpdate={openUpdate}
        setOpenUpdate={setOpenUpdate}
        loadingUpdate={loadingUpdate}
        handleUpdate={handleUpdate}
        dueDate={docs.due_date ? parseDate(docs.due_date) : null}
      />

      <EditPaidBill
        openEdit={openEditPaid}
        setOpenEdit={setOpenEditPaid}
        loadingEdit={loadingEditPaid}
        handleEdit={handleEditPaid}
        obs={editObs}
        setObs={setEditObs}
        type={editType}
        setType={setEditType}
        nfeNumber={editNfeNumber}
        setNfeNumber={setEditNfeNumber}
        dateIssue={editDateIssue}
        setDateIssue={setEditDateIssue}
        bankId={editBankId}
        setBankId={setEditBankId}
        realizedValue={editRealizedValue}
        setRealizedValue={setEditRealizedValue}
      />

      <EditBill
        openEdit={openEdit}
        setOpenEdit={setOpenEdit}
        loadingEdit={loadingEdit}
        handleEdit={handleEdit}
        obs={editObs}
        setObs={setEditObs}
        amount={editAmount}
        setAmount={setEditAmount}
        dueDate={editDueDate}
        setDueDate={setEditDueDate}
        category={editCategory}
        setCategory={setEditCategory}
        payingMethod={editPayingMethod}
        setPayingMethod={setEditPayingMethod}
        status={editStatus}
        setStatus={setEditStatus}
        predictedValue={editPredictedValue}
        setPredictedValue={setEditPredictedValue}
        type={editType}
        setType={setEditType}
        nfeNumber={editNfeNumber}
        setNfeNumber={setEditNfeNumber}
        dateIssue={editDateIssue}
        setDateIssue={setEditDateIssue}
        bankId={editBankId}
        setBankId={setEditBankId}
        supplier={editSupplier}
        setSupplier={setEditSupplier}
        center={editCenter}
        setCenter={setEditCenter}
        recurrenceType={editRecurrenceType}
        setRecurrenceType={setEditRecurrenceType}
         originalRecurrenceType={editOriginalRecurrenceType}
        installmentsCount={editInstallmentsCount}
        setInstallmentsCount={setEditInstallmentsCount}
        installmentNumber={editInstallmentNumber}
        installmentTotal={editInstallmentTotal}
      />

      <input
        type="file"
        ref={fileRef}
        style={{ display: 'none' }}
        onChange={handleSendProof}
        accept="image/*,application/pdf"
      />
      <Boleto
          open={openBoleto}
          setOpen={setOpenBoleto}
          loading={loadingBoleto}
          onSave={handleSaveBoleto}
      />
    </>
  );
}